import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';

const ChildsListing = (props) => {

    return (

        <div className="static-full-width-content">
            <div className="static-page-accordian">
                <h3 style={{ textAlign: `center`, display: `block` }}>{props.heading}</h3>
            </div>
            <div className="container">
                <div className="col-box two-col-layout"  >
                    <div className="container" >
                        <div className="col-wrapper">
                            {(() => {
                                return props.listingItems.map(({ id, url, name, image }, key) => {

                                    return <div className="cards" key={id} style={{cursor:"pointer"}}>
                                        <div className="cards-wrapper">
                                            <Link to={url}>
                                                <figure>
                                                    <div className="card-image">
                                                        {(() => {
                                                            if (image)
                                                                return <div className="image-for-card" style={{ backgroundImage: `url(${image})` }}> </div>
                                                            else
                                                                return <div className="image-for-card" style={{ background: ` #1716162e` }}> </div>
                                                        })()}
                                                    </div>
                                                    <figcaption>
                                                        <div className="card-content">
                                                            <div className="card-body">
                                                                <div className="description">
                                                                    <h2 style={{ textAlign: `center` }}>{name}</h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </figcaption>
                                                </figure>
                                            </Link>
                                        </div>
                                    </div>
                                });

                            })()}
                        </div>
                    </div>
                </div>
            </div>


        </div>


    )
}

export default ChildsListing;